import { AvailabilityState } from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useProductView } from '@context/product-view';

const REVIEWS_MIN_COUNT = 3;
const RATING_MIN_COUNT = 3;

export const useShouldShowReviewPage = (
  reviewCount: number,
  ratingSummary: number
) => {
  const { pdHasAllReviewsPage } = useFeatureFlags();
  const { variant } = useProductView();

  const isAvailable =
    variant.availability.state === AvailabilityState.CanBeBought;

  return (
    reviewCount >= REVIEWS_MIN_COUNT &&
    ratingSummary >= RATING_MIN_COUNT &&
    pdHasAllReviewsPage &&
    isAvailable
  );
};
